<script>
  export default {
    props: {
      status: {
        type: String,
        required: true
      }
    },
    data() {
      return {
      }
    },
    methods: {
      changeStatus(status) {
        this.$emit('setStatus', status);
      }
    }
  };
</script>
<template>
  <FabricDropdown right toggle-class="btn-dropdown">
    <template v-slot:button-content>
      <span
        :class="['status-item', 'text-capitalize', { 'active': status === 'active' },
                 { 'inactive': status === 'inactive' }, { 'pending': status === 'pending' }]">{{status}}</span>
    </template>
    <FabricDropdownElement
      :key="'active'"
      type="link"
      class="item"
      :value="'active'"
      @click="changeStatus('active')"><span class="status-item active">Active</span></FabricDropdownElement>
    <FabricDropdownElement
      :key="'inactive'"
      type="link"
      class="item"
      :value="'inactive'"
      @click="changeStatus('inactive')"><span class="status-item inactive">Inactive</span></FabricDropdownElement>
    <FabricDropdownElement
      :key="'pending'"
      type="link"
      class="item"
      :value="'pending'"
      @click="changeStatus('pending')"><span class="status-item pending">Pending</span></FabricDropdownElement>
  </FabricDropdown>
</template>
